import React from 'react';

import { Typography } from '../../designComponents';
import { InfoRowStyled, VerticalSpaceStyled } from '../../style/reusableStyle';
import { ContractDetailsContainerStyled } from './style';

type PropertyInformationType = {
  buildingName: string;
  buildingAddress: string;
};

const PropertyInformation = ({
  buildingName,
  buildingAddress,
}: PropertyInformationType) => {
  return (
    <ContractDetailsContainerStyled>
      <Typography
        variant="normal"
        className="section-title"
        fontColor="secondary"
        strong
      >
        PROPERTY INFORMATION
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled>
          <Typography className="title">Building Name :</Typography>
          <Typography className="value">{buildingName}</Typography>
        </InfoRowStyled>

        <InfoRowStyled>
          <Typography className="title">Property Address :</Typography>
          <Typography className="value">{buildingAddress}</Typography>
        </InfoRowStyled>
      </VerticalSpaceStyled>
    </ContractDetailsContainerStyled>
  );
};

export default PropertyInformation;
